const FILE_UPLOAD_STATUS = {
    STARTED: 'started',
    UPLOADING: 'uploading',
    SUCCESSFUL: 'successful',
    FAILED: 'failed',
    PREVIEW: 'preview',
}

export { FILE_UPLOAD_STATUS }
